export default "__VITE_ASSET__6y3dLyP7__"